import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export const Bonuses: React.FC = () => {
  const bonuses = [{
    id: 1,
    title: 'Mensajes Que Despiertan Atención Emocional',
    desc: 'Plantillas y ejemplos reales de mensajes que: generan tensión emocional, despiertan curiosidad, evitan sonar necesitada.',
    value: 37900,
    img: 'https://cdn.magicpatterns.com/uploads/wBvqVDhQmYEcM1aXUfbrwy/ChatGPT_Image_10_may_2026,_09_41_18_p.m..png'
  }, {
    id: 2,
    title: 'Cómo Dejar de Sobrepensar Después de Que Él Se Aleja',
    desc: 'Mini entrenamiento específico para: ghosting, distancia emocional, ansiedad por respuesta, obsesión mental.',
    value: 47900,
    img: 'https://cdn.magicpatterns.com/uploads/a9cpTHJ6G7iHz5QANEhZMs/ChatGPT_Image_10_may_2026,_09_44_42_p.m..png'
  }, {
    id: 3,
    title: 'La Energía Femenina Que Los Hombres No Olvidan',
    desc: 'Cómo proyectar: calma, valor, misterio, seguridad emocional. SIN actuar. SIN máscaras.',
    value: 27900,
    img: 'https://cdn.magicpatterns.com/uploads/izEkEbwb5hKk3r9u2fz83W/ChatGPT_Image_10_may_2026,_09_47_45_p.m..png'
  }, {
    id: 4,
    title: 'Reconstrucción de Autoestima Después de Relaciones Confusas',
    desc: 'Guía rápida para recuperar tu centro emocional después de: rechazo, migajas emocionales, hombres inconsistentes.',
    value: 39900,
    img: 'https://cdn.magicpatterns.com/uploads/b7Pc99QNcUoLeXYNaB2ur9/ChatGPT_Image_10_may_2026,_09_50_57_p.m..png'
  }];
  return <section className="py-16 md:py-24 px-4 bg-brand-cream relative border-y-4 border-brand-gold/30" data-id="element-19">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-30 mix-blend-multiply" data-id="element-20"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-21">
        <div className="text-center mb-12 md:mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-23">
            Si Ordenas Hoy, También Recibirás Estos BONOS GRATIS:
          </h2>
          <p className="text-xl text-gray-600" data-id="element-24">
            Diseñados para acelerar tu transformación emocional.
          </p>
        </div>

        <div className="space-y-6 md:space-y-8" data-id="element-25">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-brand-gold/20 flex flex-col md:flex-row gap-6 md:gap-8 items-center md:items-start" data-id="element-26">
              <div className="w-32 h-32 md:w-40 md:h-40 shrink-0 rounded-xl overflow-hidden shadow-md" data-id="element-27">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" data-id="element-28" />
              </div>

              <div className="flex-1 text-center md:text-left" data-id="element-29">
                <span className="inline-flex items-center gap-1 text-brand-goldDark font-bold tracking-wider uppercase text-sm mb-2" data-id="element-30">
                  <Gift className="w-4 h-4" data-id="element-31" /> BONUS #{bonus.id}
                </span>
                <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-32">
                  “{bonus.title}”
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-33">{bonus.desc}</p>

                <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4 justify-center md:justify-start" data-id="element-34">
                  <span className="text-gray-400 font-medium" data-id="element-35">
                    Valor:{' '}
                    <PriceDisplay basePriceARS={bonus.value} strikeThrough data-id="element-36" />
                  </span>
                  <span className="bg-emerald-100 text-emerald-800 font-bold px-4 py-1.5 rounded-full text-sm" data-id="element-37">
                    HOY: GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-16 bg-gradient-to-br from-brand-wine to-brand-charcoal p-1 rounded-3xl shadow-2xl" data-id="element-38">
          <div className="bg-brand-cream rounded-[22px] p-8 md:p-12 text-center border-2 border-brand-gold/50" data-id="element-39">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-40">
              Valor Total:
            </h3>
            <div className="text-2xl md:text-3xl text-gray-400 font-medium mb-6" data-id="element-41">
              MÁS DE <PriceDisplay basePriceARS={140000} strikeThrough data-id="element-42" />
            </div>
            <div className="text-brand-wine font-bold text-xl mb-2" data-id="element-43">Hoy:</div>
            <div className="text-4xl md:text-6xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-44">
              SOLO <PriceDisplay basePriceARS={25990} data-id="element-45" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};